import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $accountSettingsFormTranslations = combine(i18n.$t, ({ t }) => ({
  usernameErrors: {
    required: t('username_required_error'),
    username: t('symbols_error'),
    maxLength: t('username_max_length_error'),
    unique: t('username_unique_error'),
  },
}))
